import React from 'react';
import styled from 'styled-components';
import ConfirmModal from '@grnhse/seedling/lib/azalea/components/modals/confirm_modal';
import WarningModal from '@grnhse/seedling/lib/azalea/components/modals/warning_modal';
import { withLocalePrefix } from 'shared/utils/translation';
import Button from '@grnhse/seedling/lib/azalea/components/button';
import CardTable, {
  Cell,
  Row,
  // @ts-expect-error - TS7016 - Could not find a declaration file for module '@grnhse/seedling/lib/azalea/components/card_table'. 'node_modules/@grnhse/seedling/lib/azalea/components/card_table.js' implicitly has an 'any' type.
} from '@grnhse/seedling/lib/azalea/components/card_table';

type Props = {
  errorsPresent: boolean;
  hideDelete: boolean;
  onCancel: any;
  onDelete: any;
  onSave: any;
  skipCancelPrompt: boolean;
};

const t = withLocalePrefix('gdpr.data_retention_rules.view.edit');

export default function RetentionFooter(props: Props) {
  const {
    errorsPresent,
    hideDelete,
    onCancel,
    onDelete,
    onSave,
    skipCancelPrompt,
  } = props;

  return (
    <CardTable>
      <Row>
        <FooterCell colSpan="2">
          {!hideDelete && (
            <WarningModal
              title={t('delete_confirmation_title')}
              warningText={t('delete_confirmation_text')}
              dangerText={t('delete_confirmation_button_text')}
              submitText={t('delete_confirmation_cancel_text')}
              maxWidth="md"
              onConfirm={() => onDelete()}
            >
              <Button danger data-provides="delete">
                {t('delete')}
              </Button>
            </WarningModal>
          )}
        </FooterCell>
        <FooterCell colSpan="2">
          {skipCancelPrompt ? (
            <Button hideBg onClick={() => onCancel()}>
              {t('cancel')}
            </Button>
          ) : (
            <ConfirmModal
              title={t('cancel_confirmation_title')}
              confirmText={t('cancel_confirmation_text')}
              submitText={t('cancel_confirmation_button_text')}
              cancelText={t('cancel_confirmation_cancel_text')}
              maxWidth="md"
              onConfirm={() => onCancel()}
            >
              <Button hideBg>{t('cancel')}</Button>
            </ConfirmModal>
          )}
          <Button
            fancy
            disabled={errorsPresent}
            onClick={() => onSave()}
            data-provides="save"
          >
            {t('save')}
          </Button>
        </FooterCell>
      </Row>
    </CardTable>
  );
}

const FooterCell = styled(Cell)`
  padding: 0 15px 3px 0;
`;
